import React, { useEffect, useRef, useState } from 'react'
import classNames from 'classnames'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import Header from '../../../atoms/Header'
import Button from '../../../atoms/GoodFlipButton'
import Question from './Question'
import AnswersSummary from '../Answers'
import { setAllQuestions } from '../../../../redux/slices/questionnaireSlice'

import questionCardImg from '../../../../assets/icons/question_card_img.svg'
import screenBottomImg from '../../../../assets/icons/bottom-saperator.png'
import screenBottomSubmitImg from '../../../../assets/icons/quesions_submit_bottom.png'
import { ReactComponent as ArrowRight } from '../../../../assets/icons/right_arrow.svg'
import { sendMessageToParent } from '../../../../utils/helpers/common'

const Questions = ({ from = 'PNDS' }) => {
  const dispatch = useDispatch()
  const { questions: initQuestion } = useSelector(
    (state) => state.questionnaire,
  )
  const questions = initQuestion?.filter((q) => !q.isHide)

  const [isScaled, setScaled] = useState(false)
  const [moveToNext, setMoveToNext] = useState(false)
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(
    questions?.filter((q) =>
      Array.isArray(q?.answer) ? q.answer.length > 0 : q?.answer,
    ).length,
  )
  const [showQuestion, setShowQuestion] = useState(
    questions?.filter((q) =>
      Array.isArray(q?.answer) ? q.answer.length > 0 : q?.answer,
    ).length !== questions.length,
  )

  const questionsRef = useRef(null)
  const navigate = useNavigate()

  useEffect(() => {
    if (showQuestion) {
      scrollBottom()
    }
  }, [currentQuestionIndex, showQuestion])

  const scrollBottom = () => {
    questionsRef.current?.scrollTo({
      behavior: 'smooth',
      top: questionsRef.current.scrollHeight,
    })
  }

  useEffect(() => {
    if (showQuestion) {
      requestAnimationFrame(() => setScaled(() => true))
    }
  }, [showQuestion])

  const onBackPress = () => {
    sendMessageToParent('NAVIGATE_BACK')
    navigate(-1, { replace: true })
  }

  const onSubmitAnswer = (question_id, answer) => {
    setMoveToNext(true)
    const updatedQuestions = initQuestion.map((q) =>
      q.id === question_id ? { ...q, answer: answer } : q,
    )
    dispatch(setAllQuestions(updatedQuestions))

    if (currentQuestionIndex == questions.length - 1) {
      setShowQuestion(false)
      setMoveToNext(false)
      return
    }
    setCurrentQuestionIndex(currentQuestionIndex + 1)
    setMoveToNext(false)
  }

  const onClickContinue = () => {
    if (from === 'PNDS') {
      navigate('/result')
    } else {
      navigate('/score', { replace: true })
    }
  }

  return (
    <div className={`h-screen overflow-hidden bg-background-accent-indigo`}>
      <Header
        title="Back"
        onPressLeftIcon={onBackPress}
        showProgressBar={true}
        progress={
          questions?.filter((q) =>
            Array.isArray(q?.answer) ? q.answer.length > 0 : q?.answer,
          ).length
        }
        totalProgress={questions.length}
      >
        <div className="w-full max-w-xl">
          <div className="w-full bg-gray-200 rounded-full h-1">
            <div
              className="bg-background-brand-main h-1 rounded-full transition-all duration-500"
              style={{ width: `${10}%` }}
            />
          </div>
        </div>
      </Header>
      <div
        className={classNames(
          'px-4 mb-4 pt-4',
          'min-h-[calc(100vh-80px)] max-h-[calc(100vh-80px)]',
        )}
      >
        <div
          className="h-screen overflow-y-auto pb-6 max-h-[calc(85vh-70px)] relative z-20"
          ref={questionsRef}
        >
          <AnswersSummary />
          <div className={classNames('w-full max-w-xl')}>
            {showQuestion && questions[currentQuestionIndex] ? (
              <div
                className={classNames(
                  'flex-col gap-1 w-full max-w-xl bg-white rounded-xl shadow p-4 relative duration-200 ease-in transition-all',
                  isScaled ? 'scale-80' : 'scale-0',
                  moveToNext ? 'hidden' : 'flex',
                )}
              >
                <Question
                  answers={questions[currentQuestionIndex]?.answer}
                  question={questions[currentQuestionIndex]}
                  onSubmitAnswer={(question_id, answer) => {
                    onSubmitAnswer(question_id, answer)
                  }}
                />
                <img
                  src={questionCardImg}
                  alt="bottom_card"
                  loading="lazy"
                  className="absolute bottom-[2px] right-[3px]"
                />
              </div>
            ) : null}
          </div>
        </div>
        {/* Final submission button */}
        <div className="sticky bottom-0 pt-2 z-10 -mx-4">
          {!showQuestion && (
            <img
              src={screenBottomSubmitImg}
              alt="bottom_img"
              loading="lazy"
              className="mx-auto relative -bottom-35"
              width={309}
            />
          )}
          <div className="">
            {!showQuestion ? (
              <div className="pt-0.5 px-4 bg-white pb-4 relative">
                <Button
                  title="Continue"
                  type="goodflip_primary"
                  onClick={onClickContinue}
                  className="w-full !mx-0"
                  // disabled={loading || isLoading}
                  // loading={loading || isLoading}
                  leftIcon={null}
                  rightIcon={<ArrowRight />}
                />
              </div>
            ) : (
              <div className="pt-3 px-4 pb-4 relative">
                <img
                  src={screenBottomImg}
                  alt="bottom_img"
                  loading="eager"
                  className="mx-auto"
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Questions
